import EventInterface from '@app/Interface/EventInterface';
import UserModel from '@app/Model/UserModel';
import EventHelper from '@app/Service/EventHelper';
import { Card, CardTitle, CardFooter } from '@patternfly/react-core';
import * as React from 'react';
import { Link } from 'react-router-dom';

interface ArticleItemProps {
    event: EventInterface,
    path: string,
    pageId: number,
    currentUser: UserModel
}

const EventItem: React.FC<ArticleItemProps> = ({ event, path, pageId, currentUser }) => {
    return (
        <Card className="pf-u-mb-xl">
            <CardTitle>
                <Link to={{ pathname: path, search: `?event=${event.slug}`, state: { pageId: pageId, currentUser: currentUser } }}>
                    {event.title}
                </Link>
            </CardTitle>
            <CardFooter>
                <p><strong>Event Date(s):</strong> {EventHelper.getEventDateString(event)}</p>
                {event.eventLocation &&
                    <p><strong>Event Location:</strong> {event.eventLocation}</p>
                }
            </CardFooter>
        </Card>
    );
};

export default EventItem;